import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import TopUpGiaAccountModalContent from './TopUpGiaAccountModalContent';
import { AccountTypeDisplay } from '../constants';
import { blockInvestActionOnWeb } from '../webGate';
/** Legacy name. It is for both GIA and ISA. */
const TopUpGiaAccountModal = {
    show: (accountType, tradingAccountId, flow) => {
        if (blockInvestActionOnWeb('Add money'))
            return;
        const accountTypeText = AccountTypeDisplay[accountType];
        Modal.show(<TopUpGiaAccountModalContent accountType={accountType} tradingAccountId={tradingAccountId} hideModal={(callback) => Modal.hide(callback)}/>, {
            containerStyle: styles.modal,
            title: flow === 'buy'
                ? `You need to add money to your investment account (${accountTypeText}) to buy funds`
                : `Choose a way to fund your investment\xa0account\xa0(${accountTypeText})`,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
export default TopUpGiaAccountModal;
